import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { TemplateDashboard, QuestionTemplateDashBoard } from '@app/cp/shared/models/reftracking/TemplateDashboard';
import { TemplateConfig, TemplateConfigDefault } from '@app/cp/shared/models/reftracking/TemplateConfig';
import { QuestionTemplate, FileUpload, QustOption } from '@app/cp/shared/models/reftracking/QuestionTemplate';
import { NewTemplateCreate, TemplateOption, Steps } from '@app/cp/shared/models/reftracking/NewTemplateCreate';
import { Template, Step, StepControls, StepOption, PdfField } from '@app/cp/shared/models/reftracking/PDFTemplateEdit';
@Injectable({
  providedIn: 'root',
})
export class RefTrackingService extends BaseService {
  //array declarations
  public Step: Steps[] = [];//step
  public StepControls: NewTemplateCreate[] = [];//inner Step
  public StepOptions: TemplateOption[] = [];//Innser controls
  selectNewTemplateCreate: NewTemplateCreate;
  allQuestionTemplate: QuestionTemplate[] = [];
  allQustOption: QustOption[] = [];
  public newAttribute: any = { PropertyType: true, Option: '', Fields: '' };
  public newAttributeSteps: any = { Step: '', StepTitle: '', StepControls: this.StepControls };
  public newAttributeAddOpt: any = { QuestionType: '', PropertyType: '', Title: '', Field: '', StepOptions: this.StepOptions, Required: false, Base64Image: '' ,FieldTypeID:'00000000-0000-0000-0000-000000000000'};
  public newAttributeQuest: any = { PropertyType: true, Option: '' };
  public newAttributeAddOptQuest: any = { QuestionType: '', PropertyType: '', Title: '', Options: this.allQustOption, Required: false, Base64Image: '',FieldTypeID:'00000000-0000-0000-0000-000000000000' };
  ///Add customer
  public newAttributeAddCustomer: any = {
    CustomerId: '00000000-0000-0000-0000-000000000000', SentWithInvoice: false, SavePDFCopy: false, SendEmail: false,
    EmailAddresses: '', ConnectToAPI: false, UserKey: '', PassKey: '', IsActive: false, IsDefaultTemplate: false,
    CustomerConfigID: '00000000-0000-0000-0000-000000000000',
    PostURL: ''
  };

  public IsDefaultTemplate: boolean = false;
  //compare
  public ComparePreview: any;
  public StepCompareB: string;
  public StepCompareA: string;
  public JsonPreview: string;
  //end
  selectFileUpload: FileUpload;
  PDFSubRowCount: any;
  QuestSubRowCount: any;
  PDFOptRowCount: any;
  QustOptRowCount: any;
  TemplateConfig: TemplateConfig[] = [];
  SelectTemplateConfigDefault: TemplateConfigDefault;
  selectQuestionTemplate: QuestionTemplate;
  // public ConfirmationText: string = 'Are you sure you want to continue?';
  public ConfirmationText: string = 'Are you sure you want to delete?';
  public Confirmation: string = this.ConfirmationText;
  public TemplateId: string;
  public TemplateName: string;
  public ConfigCustomerId: string;
  public questionResponseType: string;
  public PDFFileName: string;
  public CreatedBY: string;
  public saveType: number;
  public PreviewDataList: any[] = [];
  public TemplateIdNewTemp: string="";
  public VersionUniqueID: string = '00000000-0000-0000-0000-000000000000';
  public StepNo: number = 1; //steps number for Mobile Preview
  public allTemplate: Template[];
  //delete
  public IsPreView: boolean = false;
  public ISNextView: boolean = false;
  public IsSaveButton: boolean = false;
  public deletePDFTemplateId: any = 0;
  public deleteStatus: any = 0;
  public DefaultGUID: any = '00000000-0000-0000-0000-000000000000'
  public QuestionTemplateID: string = '00000000-0000-0000-0000-000000000000';
  public NextButtonText: string = "Next";
  public SignalR: string;
  constructor(_http: HttpClient) {
    super(_http);
    this.baseUrl = this.rootUrl + "RefTracking/";
    // this.baseUrl = "http://localhost:53158/api/RefTracking/";
    this.SignalR = this.rootUrlSignalR;//SignalR for checking the active session in the browser while editiong the same template
  }
  getComponents(id: any): Observable<any> {
    let url_call: string = this.baseUrl + "GetComponents/" + id
    return super.get(url_call);
  }
  getFormData(id: any): Observable<any> {
    let url_call: string = this.baseUrl + "GetFormData/" + id
    return super.get(url_call);
  }
    getPDFTemplateDashBoard(searchText: any, pageNumber: any, pageSize: any, sortField: string, sortDir: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetPDFTemplateDashBoard/" + searchText + "/" + pageNumber + "/" + pageSize + "/" + sortField + "/" + sortDir;
    return super.get(url_call);
  }
  getQuestionTemplateDashBoard(searchText: any, pageNumber: any, pageSize: any, sortField: string, sortDir: string): Observable<any> {
    let url_call: string = this.baseUrl + "GetQuestionTemplateDashBoard/" + searchText + "/" + pageNumber + "/" + pageSize + "/" + sortField + "/" + sortDir;
    return super.get(url_call);
  }
  getCustomers(SerchaText, TemplateId): Observable<any> {
    let url_call: string = this.baseUrl + "GetCustomers/" + SerchaText + "/" + TemplateId;
    return super.get(url_call);
  }
  getSteps(TemplateId: any, VersionUniqueID: any): Observable<any> {
    let url_call: string = this.baseUrl + "GetSteps/" + TemplateId + "/" + VersionUniqueID;
    return super.get(url_call);
  }
  GetQuestionTemplatesDetails(QuestionTemplateID: any): Observable<any> {
    let url_call: string = this.baseUrl + "GetQuestionTemplatesDetails/" + QuestionTemplateID;
    return super.get(url_call);
  }
  saveConfigurations(Details: any): Observable<any> {
    let url_call: string = this.baseUrl + "SaveTtemplateConfigurations"
    return super.post(url_call, Details);
  }
  saveNewQuestionTemplateSave(Details: any): Observable<any> {
    let url_call: string = this.baseUrl + "SaveQuestionTemplate"
    return super.post(url_call, Details);
  }
  fileUpload(formData: FormData): Observable<any> {
    const url_call: string = this.baseUrl + "UploadPDF";
    return this._http.post(url_call, formData);
}
  saveNewTemplate(Details: any): Observable<any> {
    let url_call: string = this.baseUrl + "SaveSteps"
    return super.post(url_call, Details);
  }
  getTemplateConfiguration(TemplateId: any): Observable<any> {
    let url_call: string = this.baseUrl + "GetTemplateConfiguration/" + TemplateId
    return super.get(url_call);
  }
  getResponseType(): Observable<any> {
    let url_call: string = this.baseUrl + "GetResponseType"
    return super.get(url_call);
  }
  getTemplateForms(TemplateId, StepSet) {
    let url_call: string = this.baseUrl + "GetMobilePreview/" + TemplateId + "/" + StepSet;
    return super.get(url_call);
  }
  deletePDFTemplateDashForms(TemplateId) {
    let url_call: string = this.baseUrl + "DeletePDFTemplate/"
    return super.delete(url_call, TemplateId);
  }
  deleteQuestemplateDashForms(QuestionTemplateID) {
    let url_call: string = this.baseUrl + "DeleteQuestionTemplate/"
    return super.delete(url_call, QuestionTemplateID);
  }
  importQuestionControls(QuestionTemplateID) {
    let url_call: string = this.baseUrl + "GetQuestionDetails/" + QuestionTemplateID
    return super.get(url_call);
  }
  getJson(): Observable<any> {
    let url_call: string = this.baseUrl + "GetJsonKey"
    return super.get(url_call);
  }
  getJsonPreview(TemplateID): Observable<any> {
    let url_call: string = this.baseUrl + "GetJsonPreview/" + TemplateID
    return super.get(url_call);
  }
  CheckPDFTemplateIsBlocked(Id: any, TemplateType: any): Observable<any> {
    let url_call: string = this.baseUrl + "CheckPDFTemplateIsBlocked/" + Id + "/" + TemplateType;
    return super.get(url_call);
  }
  SaveBlockPDFTemplate(Id: any, TemplateType: any, ConnectionId: any): Observable<any> {
    let url_call: string = this.baseUrl + "SaveBlockPDFTemplate/" + Id + "/" + TemplateType + "/" + ConnectionId;
    return super.get(url_call);
  }
  //09102020 mmddyyyy Vishnu
  getFieldType(): Observable<any> {
    let url_call: string = this.baseUrl + "GetFieldType"
    return super.get(url_call);
  }

  copyPDFTemplate(Details: any): Observable<any> {
    let url_call: string = this.baseUrl + "CopyPDFTemplate"
    return super.post(url_call, Details);
    }

    CopyQuestionTemplate(QuestionTemplateId: string): Observable<any> {
        let model = {
            questionTemplateId: QuestionTemplateId
        }
        let url_call: string = this.baseUrl + "CopyQuestionTemplate";
        return super.post(url_call, model);
    }

    downloadFile(TemplateID): Observable<any> {
      let url_call: string = this.baseUrl + "GetPDFTemplateByTemplateID/"+TemplateID
      return super.getWithResponseType(url_call, 'blob');
    }
}
